import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import { useDownload } from "@/lib/downloads";

export const Navbar = () => {
  const location = useLocation();
  const onDocs = location.pathname.startsWith("/docs");
  const on10x = location.pathname === "/10x-dev";
  const { primary } = useDownload();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 border-b border-pg bg-[var(--pg-bg)]/90 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-14 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-2 group"
        >
          <img
            src="/poly-grid-logo.png"
            alt="Poly Grid"
            className="h-9 w-auto"
            data-testid="nav-logo-image"
          />
          <span className="sr-only">Poly Grid</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-[13px] tag-label text-[var(--pg-text-dim)]">
          <Link
            to="/"
            data-testid="nav-link-features"
            className={`hover:text-white transition-colors ${!onDocs ? "text-white" : ""}`}
          >
            Features
          </Link>
          <a
            href="/#pricing"
            data-testid="nav-link-pricing"
            className="hover:text-white transition-colors"
          >
            Pricing
          </a>
          <a
            href="/#faq"
            data-testid="nav-link-faq"
            className="hover:text-white transition-colors"
          >
            FAQ
          </a>
          <Link
            to="/10x-dev"
            data-testid="nav-link-10x-dev"
            className={`hover:text-white transition-colors ${on10x ? "text-white" : ""}`}
          >
            10x Dev
          </Link>
          <Link
            to="/docs"
            data-testid="nav-link-docs"
            className={`hover:text-white transition-colors ${onDocs ? "text-white" : ""}`}
          >
            Docs
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          <Button
            asChild
            variant="ghost"
            size="sm"
            className="hidden sm:inline-flex h-9 rounded-sm tag-label text-[var(--pg-text-dim)] hover:text-white hover:bg-pg-surface-2"
          >
            <Link to="/docs" data-testid="nav-cta-docs">
              Docs
            </Link>
          </Button>
          <Button
            asChild
            data-testid="nav-cta-download"
            className="h-9 rounded-sm bg-cyan-accent text-black hover:bg-cyan-accent/90 font-display font-bold tag-label px-4"
            style={{ backgroundColor: "var(--pg-cyan)" }}
          >
            <a
              href={primary.url}
              download={!primary.external}
              target={primary.external ? "_blank" : undefined}
              rel={primary.external ? "noopener noreferrer" : undefined}
              onClick={() =>
                trackEvent("download_app", {
                  location: "navbar",
                  tier: "free",
                  platform: primary.platform,
                })
              }
            >
              <Download className="w-4 h-4 mr-1.5" />
              Download
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
